// Import gqlV2 from v2 generated code
import { gqlV2 } from '@fly/store';

/**
 * GraphQL v2 queries for environments - uses Relay-style connections
 * These queries work with /fly/api/v2/graphql endpoint
 */

export const getEnvironmentsQuery = gqlV2(/* GraphQL */ `
  query GetFlyEnvironments(
    $names: [String!]
    $search: String
    $first: Int
    $after: String
  ) {
    flyEnvironments {
      searchEnvironments(
        where: { names: $names, search: $search }
        first: $first
        after: $after
      ) {
        edges {
          node {
            id
            name
            description
            color
            tokenCount
            releaseCount
            deploymentCount
            deploymentDeltas {
              id
              workflowName
              repositoryOwner
              repositoryName
              currentDeployment {
                name
                number
                environmentName
                lastPulled
                imageCount
                summary
                shortSummary
                title
                uploadedBy
                url
                repositoryOwner
                repositoryName
                isLocal
                commitCount
                pullRequestCount
                images {
                  name
                  pulled
                }
              }
              previousDeployment {
                name
                number
                environmentName
                lastPulled
                imageCount
                summary
                shortSummary
                title
                uploadedBy
                url
                repositoryOwner
                repositoryName
                isLocal
                commitCount
                pullRequestCount
                images {
                  name
                  pulled
                }
              }
              totalCommitCount
              totalPullRequestCount
              releaseCount
              deployType
              daysSinceLastDeploy
              cumulativeSummary
              cumulativeTitle
              cumulativeShortSummary
              isLatestOnEnvironment
            }
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
      }
    }
  }
`);

export const getEnvironmentDeploymentsQuery = gqlV2(/* GraphQL */ `
  query GetEnvironmentDeployments(
    $environmentName: String!
    $search: String
    $first: Int
    $after: String
  ) {
    flyEnvironments {
      searchEnvironmentDeployments(
        where: { environmentName: $environmentName, search: $search }
        first: $first
        after: $after
      ) {
        edges {
          node {
            id
            workflowName
            repositoryOwner
            repositoryName
            currentDeployment {
              name
              number
              environmentName
              lastPulled
              imageCount
              summary
              shortSummary
              title
              uploadedBy
              url
              repositoryOwner
              repositoryName
              isLocal
              commitCount
              pullRequestCount
              images {
                name
                pulled
              }
            }
            previousDeployment {
              name
              number
              environmentName
              lastPulled
              imageCount
              summary
              shortSummary
              title
              uploadedBy
              url
              repositoryOwner
              repositoryName
              isLocal
              commitCount
              pullRequestCount
              images {
                name
                pulled
              }
            }
            totalCommitCount
            totalPullRequestCount
            releaseCount
            deployType
            daysSinceLastDeploy
            cumulativeSummary
            cumulativeTitle
            cumulativeShortSummary
            isLatestOnEnvironment
          }
          cursor
        }
        pageInfo {
          hasNextPage
          hasPreviousPage
          endCursor
          startCursor
        }
      }
    }
  }
`);
